export default "__VITE_ASSET__CtpuDp7J__"